<!-- Header Container
================================================== -->
<header id="header-container" class="fullwidth transparent-header">

  <!-- Header -->
  <div id="header">
    <div class="container">

      <!-- Left Side Content -->
      <div class="left-side">

        <!-- Logo -->
        <!-- <div id="logo">
          <a href="index.html"><img src="assets/images/logo2.png" data-sticky-logo="assets/images/logo.svg" data-transparent-logo="assets/images/logo2.png" alt=""></a>
        </div> -->

        <!-- Main Navigation -->
        <!-- <nav id="navigation">
          <ul id="responsive"> -->
            <!-- <li><a href="#">หน้าหลัก</a>
              <ul class="dropdown-nav">
                <li><a routerLink="/index">หน้าหลัก</a></li>
                <li><a routerLink="/contact_us">ติดต่อเรา</a></li>
              </ul>
            </li> -->
            <!-- <li><a routerLink="/index">หน้าหลัก</a></li> -->
            <!-- <li><a (click)="goToIndex()" style="font-family: 'Kanit'">หน้าหลัก</a></li> -->

            <!-- <li><a routerLink="/contact_us">ติดต่อเรา</a></li> -->
            <!-- <li><a href="#" style="font-family: 'Kanit'">ดาวน์โหลด</a>
              <ul class="dropdown-nav">
                <li><a href="../assets/book_business_man.pdf" target="_blank" style="font-family: 'Kanit'">คำอธิบายรหัสธุรกิจ TSIC</a></li>
                <li><a href="book_business_man.pdf" target="_blank" style="font-family: 'Kanit'">คำแนะนำการใช้งาน</a></li>
              </ul>
            </li>
          </ul>
        </nav> -->
        <div id="meunMobile"></div>




        <div class="clearfix">





        </div>
        <!-- Main Navigation / End -->
      </div>
      <!-- Left Side Content / End -->


      <!-- Right Side Content / End -->
      <div class="right-side">
        <!-- User Menu -->
        <div class="header-widget">

          <!-- Messages -->
          <!-- <div class="footer-row">
            <div class="footer-row-inner">
              <select class="selectpicker language-switcher" data-selected-text-format="count" data-size="2">
                <option selected>TH</option>
                <option>EN</option>
              </select>
            </div>
          </div> -->

        </div>
        <!-- User Menu / End -->

        <!-- Mobile Navigation Button -->
        <!-- <span class="mmenu-trigger">
					<button class="hamburger hamburger--collapse" type="button">
						<span class="hamburger-box">
							<span class="hamburger-inner"></span>
						</span>
					</button>
				</span> -->

      </div>
      <!-- Right Side Content / End -->

    </div>
  </div>
  <!-- Header / End -->

</header>
